import { useAtom } from "jotai";

import { pageAtom, subPageAtom } from "@/state/page";
import { Page } from "@/utils/getCurrentPage";

export const useNavigation = () => {
  const [page, setPage] = useAtom(pageAtom);
  const [subpage, setSubpage] = useAtom(subPageAtom);

  const navigate = (newPage: Page, newSubpage: string = "") => {
    setPage(newPage);
    setSubpage(newSubpage);
  };

  return {
    navigate,
    page,
    subpage,
  };
};
